"use client";

import {JSX} from "react";

import {useTranslation} from "@/shared/i18n";
import {Typography} from "@/shared/ui/data-display/typography";

import "./styles/inquiry-modal-header.scss";

export function InquiryModalHeader({unitName}: {unitName?: string}): JSX.Element {
    const {t} = useTranslation("booking");

    return (
        <div className="inquiry-modal-header">
            <div className="inquiry-modal-header__left">
                <Typography as="h2" size={{desktop: 20, mobile: 18}} weight={700}>
                    {t("requestInformation")}
                </Typography>
                {unitName && <p className="inquiry-modal-header__subtitle">{unitName}</p>}
            </div>
        </div>
    );
}
